import * as React from "react";
import * as _ from "lodash";
import { translate } from "react-i18next";
import { ITranslatedComponent, ITypefamilyMap } from "../../redux/reducers/generalReducer";
import { ModelyearDto, ResourceListOfModelyearDto } from "../../services/Client";
import Button from "../../components/Button";
import Dialog from "../../components/Dialogs/Dialog";

import ModelYearsControl from "../../components/ModelYearsControl";
import { Tab, TabProps } from "semantic-ui-react";
import { ICopyPSL } from "../OptionsView/PSL/PslCopy";
import ModeltypeCopyDialog, {IModelyearTypefamilyFilter} from "./ModeltypeCopyDialog";
import { PropertiesKey } from "../OptionsView/OptionsViewUtils";

interface IModeltypeBasicSelectionDialogProps extends ITranslatedComponent {
    /**
     * called when the user clicks on select button
     * @param value model year to be selected
     */
    onSelect?(value: ModelyearDto): void;

    /**
     * called when the user clicks on cancel
     */
    onCancel?(): void;

    /** Model years to which the user has access */
    userModelyears: ResourceListOfModelyearDto;

    onCopyModeltype(value: IModelyearTypefamilyFilter, withSequence: boolean): void;

    /** All available typefamilies */
    typefamilyMap?: ITypefamilyMap;

    /** value to be set as predefined */
    value?: IModelyearTypefamilyFilter;

}

interface IModeltypeBasicSelectionDialogState {
    selectedItem?: ModelyearDto;

    /** Selected copy PSL. */
    selectedCopyDerivates:IModelyearTypefamilyFilter;

    /** currently selected tab */
    activeTab: number | string;
    isCopyOkClicked:boolean;
}

/**
 * shows the dialog to fill the properties for a new modeltype
 */
class ModeltypeBasicSelectionDialog extends React.Component<IModeltypeBasicSelectionDialogProps, IModeltypeBasicSelectionDialogState>
{
    constructor(props: IModeltypeBasicSelectionDialogProps) {
        super(props);
        this.state = {
            selectedCopyDerivates: {},
            activeTab: 0,
            selectedItem:undefined,
            isCopyOkClicked:false,
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCopyChange = this.handleCopyChange.bind(this);
    }

    private handleSelect() {
        const { selectedItem } = this.state;
        if (this.props.onSelect && selectedItem) {
            this.props.onSelect(selectedItem);
        }
    }
    onClickOk = (): void => {
        const { selectedItem,activeTab } = this.state;
        switch (activeTab) {
            case 0:
                if (this.props.onSelect && selectedItem) {
                    this.props.onSelect(selectedItem);
                }
                break;
            case 1:
                this.setState({isCopyOkClicked:true});
                break;
            default:
                break;
        }
    }
    private handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }
    handleCopyChange(copyPSL:IModelyearTypefamilyFilter) {
        this.setState({selectedCopyDerivates: copyPSL});
    }
    validateCopyInput(selectedCopyPSL: IModelyearTypefamilyFilter): boolean {
        const props = ["sourceModelyear", "sourceTypefamily", "targetModelyear", "targetTypefamily"];
        let valid = true;
        _.forEach(props, (p) => {
            if (valid && selectedCopyPSL[p] === undefined) {
                valid = false;
            }
        });
        return valid;
    }
    validateInput(selectedYear: ModelyearDto | undefined): boolean {
        if(!selectedYear) return false;
        const props = [ "mj4"];
        let valid = true;
        _.forEach(props, (p) => {
            if (valid && selectedYear[p] === undefined) {
                valid = false;
            }
        });
        return valid;
    }
    validateInputInternal = (): boolean => {
        const {selectedItem, selectedCopyDerivates,  activeTab} = this.state;
        switch (activeTab) {
            case 0:
                return this.validateInput(selectedItem);
            case 1:
                return this.validateCopyInput(selectedCopyDerivates);
            default:
                return false;
        }
    }
    render() {
        const { userModelyears, t } = this.props;
        const { selectedItem } = this.state;

        let actions =
            [
                (
                    <Button
                        key={"submitButton"}
                        id="modelyear_submit"
                        icon={"checkmark"}
                        disabled={!this.validateInputInternal()}
                        onClick={this.onClickOk}
                    />
                ),
                (
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={this.handleCancel}
                    />
                )
            ];
        return (
            <Dialog
                title=""
                open={true}
                actions={actions}

            >
                <Tab
                    onTabChange={(event: React.MouseEvent<HTMLDivElement>, data: TabProps) => this.setState({ activeTab: data.activeIndex ? data.activeIndex : 0 })}
                    panes={[
                        {
                            menuItem: this.props.t("LOAD_DERIVATES"),
                            render: () => (
                                <Tab.Pane attached={false}>
                                    {userModelyears.elements && userModelyears.elements.length > 0 ?
                                        <ModelYearsControl
                                            modelyears={userModelyears}
                                            selectedItem={selectedItem}
                                            selectionChanged={(dto: ModelyearDto) => this.setState({ selectedItem: dto })}
                                        />
                                        : <>{this.props.t("MISSING_ACCESS_RIGHTS")}</>
                                    }
                                </Tab.Pane>
                            )
                        },
                        {
                            menuItem: this.props.t("COPY_DERIVATES"),
                            render: () => (
                                <Tab.Pane attached={false}>
                                    <ModeltypeCopyDialog
                                        value={this.state.selectedCopyDerivates}
                                        onChange={this.handleCopyChange}
                                        onCopyModeltype={this.props.onCopyModeltype}
                                        userModelyears={this.props.userModelyears}
                                        typefamilyMap={this.props.typefamilyMap}
                                        isCopyOkClicked={this.state.isCopyOkClicked}
                                    />
                                </Tab.Pane>
                            )
                        }
                    ]}
                />

            </Dialog>
        );
    }
}
export default translate("MT_BASIC_VIEW")(ModeltypeBasicSelectionDialog);



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModeltypeBasicSelectionDialog.tsx